import { generateUuid } from '@lib/uuid';
import {
  FlexibleBlock,
  FlexibleBlockBrick,
  FlexibleBlockModifier,
  FlexibleBlockTemplate,
  getPortalBlockSizeLimits,
  PortalBlockPlace,
  PortalBlockType,
} from '@nx-frontend/shared/types';
import { patchObject } from '@nx-frontend/shared/utils';
import { getFlexibleBlockTemplate } from './get-flexible-block-template';
import { modifyBricks } from './utils/modify-bricks';

interface CreateFlexibleBlockProps extends Partial<Pick<FlexibleBlock, 'removable' | 'ghost' | 'ghostId'>> {
  template: FlexibleBlockTemplate;
  pageId: string;
  modifier?: FlexibleBlockModifier;
  place?: PortalBlockPlace;
  index?: number;
  blockId?: string;
}

export const createFlexibleBlock = ({
  template,
  index,
  removable = true,
  place = 'page_body',
  blockId = generateUuid(),
  modifier: { bricks: modifierBricks, ...modifierRest } = {},
  ghost,
  ghostId,
  pageId,
}: CreateFlexibleBlockProps): FlexibleBlock => {
  const { colsDefault: colspan, rowsDefault: rowspan } = getPortalBlockSizeLimits<FlexibleBlock>({
    type: PortalBlockType.FLEXIBLE,
    template,
  });

  const block = getFlexibleBlockTemplate(template);

  const bricks: FlexibleBlockBrick[] = modifyBricks(block.bricks, modifierBricks).map((brick) => ({
    ...brick,
    id: brick.id ?? generateUuid().slice(-6),
  }));

  const newBlock = patchObject<FlexibleBlock>(
    {
      ...block,
      id: blockId,
      type: PortalBlockType.FLEXIBLE,
      template,
      colspan,
      rowspan,
      index: index ?? 0,
      place,
      actions: [],
      mediaSizes: ['base', 'md', 'lg'],
      enabled: true,
      removable,
      ghost,
      ghostId,
      pageId,
      data: [],
      ...(bricks.length ? { bricks } : null),
    },
    modifierRest,
    true
  );
  return newBlock;
};
